import React, { useEffect, useState, useRef } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Sling as Hamburger } from 'hamburger-react';
import 'transition-style';
import linkTree from "../../img/linktree.svg";

const NavBar = () => {
  const nav = useRef<HTMLDivElement | null>(null);
  const navLinks = useRef<HTMLDivElement | null>(null);
  const navLogos = useRef<HTMLDivElement | null>(null);
  const navHamburger = useRef<HTMLDivElement | null>(null);
  const [isOpen, setOpen] = useState(false);

  const closeNav = (e: MouseEvent) => {
    if (
      navLinks.current &&
      navHamburger.current &&
      !navLinks.current.contains(e.target as Node) &&
      !navHamburger.current.contains(e.target as Node)
    ) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', closeNav);
    return () => document.removeEventListener('mousedown', closeNav);
  }, []);

  useEffect(() => {
    const toggleClass = (ref: React.RefObject<HTMLDivElement>, className: string) => {
      if (ref.current) {
        ref.current.classList.toggle(className, isOpen);
      }
    };

    toggleClass(nav, 'open');
    toggleClass(navLinks, 'open');
    toggleClass(navLogos, 'open');
    toggleClass(navHamburger, 'open');
  }, [isOpen]);

  return (
    <header className='navbar-component' data-testid='navbar-component'>
      <nav ref={nav}>
        <Link to="/" className="nav-logo">
          <div className='nav-logos' ref={navLogos}>
            <span id='tahin'>Tahin</span><span id='raw'>.raw</span>
          </div>
        </Link>
        <div className="nav-links" ref={navLinks}>
          <ul onClick={() => setOpen(false)}>
            <li><NavLink to="/" className={({ isActive }) => 'nav-link' + (isActive ? ' selected' : '')}>Accueil</NavLink></li>
            <li><NavLink to="/catalogue" className={({ isActive }) => 'nav-link' + (isActive ? ' selected' : '')}>Catalogue</NavLink></li>
            <li><NavLink to="/prestations" className={({ isActive }) => 'nav-link' + (isActive ? ' selected' : '')}>Prestations</NavLink></li>
            <li><NavLink to="/apropos" className={({ isActive }) => 'nav-link' + (isActive ? ' selected' : '')}>À propos</NavLink></li>
            <li><NavLink to="/contact" className={({ isActive }) => 'nav-link' + (isActive ? ' selected' : '')}>Contact</NavLink></li>
            <li className='nav-linktree'><a href="https://linktr.ee/Tahin.raw" target='_blank' rel="noreferrer noopener" className='nav-link'><img src={linkTree} alt="Logo de linktree" id="linktree" /></a></li>
          </ul>
        </div>
      </nav>

      <div className="nav-hamburger" ref={navHamburger}>
        <Hamburger toggled={isOpen} toggle={setOpen} aria-label="Menu" />
      </div>
    </header>
  );
};

export default NavBar;
